var exports = {
  "kL": "GuildNotificationSettingsModal.module__container___OExlcX",
  "uW": "GuildNotificationSettingsModal.module__section___OExlcX",
  "Gf": "GuildNotificationSettingsModal.module__sectionTitle___OExlcX",
  "yV": "GuildNotificationSettingsModal.module__sectionDescription___OExlcX",
  "nv": "GuildNotificationSettingsModal.module__notificationSection___OExlcX",
  "RG": "GuildNotificationSettingsModal.module__suppressSection___OExlcX",
  "Sj": "GuildNotificationSettingsModal.module__mobilePushSection___OExlcX",
  "dY": "GuildNotificationSettingsModal.module__overridesSection___OExlcX",
  "dr": "GuildNotificationSettingsModal.module__overridesHeader___OExlcX",
  "bY": "GuildNotificationSettingsModal.module__overridesHeaderCell___OExlcX",
  "u1": "GuildNotificationSettingsModal.module__overridesHeaderCellLeft___OExlcX",
  "c": "GuildNotificationSettingsModal.module__overridesHeaderCellMute___OExlcX",
  "IC": "GuildNotificationSettingsModal.module__overrideItem___OExlcX",
  "sr": "GuildNotificationSettingsModal.module__overrideHeader___OExlcX",
  "yW": "GuildNotificationSettingsModal.module__channelInfo___OExlcX",
  "p": "GuildNotificationSettingsModal.module__channelIcon___OExlcX",
  "E8": "GuildNotificationSettingsModal.module__channelDetails___OExlcX",
  "HA": "GuildNotificationSettingsModal.module__channelName___OExlcX",
  "yb": "GuildNotificationSettingsModal.module__categoryName___OExlcX",
  "Z5": "GuildNotificationSettingsModal.module__mobileOverrideOptions___OExlcX",
  "Ue": "GuildNotificationSettingsModal.module__desktopNotificationOptions___OExlcX",
  "of": "GuildNotificationSettingsModal.module__checkboxCell___OExlcX",
  "DT": "GuildNotificationSettingsModal.module__removeButton___OExlcX",
  "kI": "GuildNotificationSettingsModal.module__iconTertiary___OExlcX",
};

module.exports = exports;
